export default __webpack_public_path__ + "static/media/phone.60174e4c.svg";